import { createAction } from '@reduxjs/toolkit';

export const recommendedProductsRequestComplete = createAction(
  'richRelevance/recommendedProductsRequestComplete',
);
